import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "asterisk",
  "use": "asterisk-usage",
  "viewBox": "0 0 6 6",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 6 6\" id=\"asterisk\"><g transform=\"translate(0 -7.513)\"><rect width=\"6\" height=\"6\" transform=\"translate(0 7.513)\" fill=\"none\" /><path d=\"M-1.084-6,.142-7.433,1.368-6l.768-.561-.96-1.61L2.845-8.88l-.3-.9L.777-9.368.614-11.214h-.96L-.508-9.353l-1.772-.428-.3.9,1.669.709-.945,1.61Z\" transform=\"translate(3 19)\" fill=\"#ff1e1e\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol